import { render, staticRenderFns } from "./SeparatedBreakdown.template.vue?vue&type=template&id=8ca82066&scoped=true&"
var script = {}
import style0 from "./SeparatedBreakdown.template.vue?vue&type=style&index=0&id=8ca82066&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca82066",
  null
  
)

export default component.exports